export default "__VITE_PUBLIC_ASSET__436c0e7a__"